<template>
    <div class="">
        <div class="w-full h-[32em] bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/wp-content/uploads/2021/10/img_7710-scaled.jpg')] mb-6"></div>

        <p class="text-lg text-dim_dark mb-6">Сложные потолки - наша любимая работа!</p>

        <button class="rounded text-xl text-black">Смотреть работы<span class="mdi mdi-arrow-right ml-2 text-lg"></span></button>
    </div>
</template>
